module.exports = __webpack_public_path__ + "img/ua_performance.adf973e8.png";